import React, { useState, useEffect,useContext } from "react";
import TextPargraph from "../../utils/TextParagraph";
import { BrowserView, MobileView,isMobile } from "react-device-detect";
import {useFetch} from "../../api/FetchApiData";
import './spinner.css';
import { MediaUrl } from "../../utils/Media";
import { useNavigate } from "react-router-dom";
import removeIcon from '../../icons/remove.png';
import Select from "react-select";
import { Rating } from "react-simple-star-rating";
import DatePicker, { DateObject } from 'react-multi-date-picker';

if (isMobile)
    import('./itempanier_mob.css').then(() => {});
else
    import('./itempanier.css').then(() => {});

export default function ItemInPanier({orArticlesRef,Item,setPanier})
{
    const [_Item,_setItem] = useState({...Item});
    const [stockNotif,setStockNotif] = useState({color:'green',text:Item.stock + 'en stock'});
    const [Enabled,setEnabled] = useState({enabled:true, bg:'white',color:'black'});
    const [delivers,setDelivers] = useState([]);
    const [locationDates,setLocationDates] = useState([]);
    const fetchData = useFetch();
    const navigator = useNavigate();

    const DeliverOption = (deliver)=>{
        let img_src = '/images/icons/delivry/delivry.png';
        if(!!deliver.logo)
            img_src = MediaUrl(deliver.logo.image);
        return(
        <div key={deliver.label} style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',fontSize:'small',}}>
            <div style={{display:'block',textAlign:'center',width:'25%',margin:'0px'}}>
                <img src={img_src} style={{width:'20px',borderRadius:'5px',margin:'auto'}} />
                {!!deliver.note && <div style={{padding:'0px',marginTop:'-5px',textAlign:'center'}}><span style={{color:'gray',fontSize:'x-small',margin:'0px',padding:'0px'}}>Note: 2/5</span></div>}
            </div>
            <div style={{maxWidth:'70%',margin:'auto'}}>
                <h5 style={{margin:'0px',marginBottom:'0px',padding:'0px'}}><span style={{marginRight:'10px'}}>{deliver.title}</span></h5>
                {!!deliver.next_fret && <span style={{color:'gray',fontSize:'small',display:'block'}}> {deliver.next_fret.arr_date.arr_date_label} 
                    </span>}
                {(deliver.next_fret===undefined || deliver.next_fret===null) && <span style={{color:'gray',fontSize:'xx-small',display:'block',margiTop:'-15px'}}>Prochain envoie Inconnu
                    </span>}
            </div>
        </div>)
    }
    
    const [deliver,setDeliver] = useState({value:{id:9999,title:'Aucune livraison'},label:DeliverOption({title:'Aucune livraison'})});

    useEffect(()=>{
        let _delivers = [];
        Item.delivers.forEach(element => {
            _delivers.push({value:{id:element.id,title:element.title},label:DeliverOption(element)})
        });
        setDelivers([..._delivers]);
    },[Item.delivers])

    useEffect(()=>{
        if (Item.location_dates) 
        {
            const converted = Item.location_dates.map(d =>
            new DateObject({ date: d.date, format: "YYYY-MM-DD" }));
            setLocationDates(converted);
        }
    },[_Item.id,Item.location_dates])


    useEffect(()=>{
        if(_Item.article.stock<_Item.quantity)
        {setStockNotif({color:'orangered',text:'stock insuffisant, approvisionnemt le '+_Item.article.approvisionnement});}
        else
        {setStockNotif({color:'green',text:_Item.article.stock+" en stock"});}  
    },[_Item.quantity])

    useEffect(()=>{
        /*
        if(_Item.enabled)
        {
            setEnabled({enabled:true, bg:'white',color:'black'});
        }
        else
        {
            setEnabled({enabled:false, bg:'whitesmoke',color:'gray'});
        }
        */
    },[_Item.enabled])

    const remove=()=>
    {
        const _data = {id:_Item.id};
        fetchData.DeleteData(_data,'panier/item/').then((result)=>{
            if(result.result)
            {
                setPanier({...result.panier});
            }
        })
            
    }

    const onQuantityChange = (quantity)=>
    {
        if(quantity==='' || quantity===undefined || quantity===null)
            return;
        fetchData.PostData({id:_Item.id,quantity:quantity},'panier/item/').then((result)=>{
            console.log(result);
            if(result.result)
            {_setItem({...result.item});setPanier({...result.panier});}
        });
    }

    const onDeliverChange = (deliver)=>{
        fetchData.PostData({id:_Item.id,deliver_id:deliver},'panier/item/').then((result)=>{
            if(result.result)
            {_setItem({...result.item});setPanier({...result.panier});}
        });
        
    }

    const onLocationDatesChange = (dates)=>{
        let _dates = dates.map(d=>new Date(d).toISOString());
        console.log(_dates);
        fetchData.PostData({id:_Item.id,location_dates:_dates},'panier/item/').then((result)=>{
        if(result.result)
        {
            _setItem({...result.item});        
            setPanier({...result.panier});
    }});
        
    }

    const parse_date=(datestr)=>{
        return new Date(datestr);
    }
    
    return(
            <fieldset className="Panier-Item" style={{backgroundColor:Enabled.bg,color:Enabled.color}}>
                    <img src={MediaUrl(_Item.article.image)} style={{verticalAlign:'middle',width:'15%'}} />
                    <div className="article-info" style={{verticalAlign:'middle',display:'inline-block'}}>
                        <h3 onClick={e=>{navigator(`/product/${_Item.article.id}`)}}>{_Item.article.title}</h3>
                        <h4 > Reference : {_Item.article.id} {!_Item.deliver && <span className="item-disabled" style={{color:'orange',paddingLeft:'20px'}}> Veuillez sélectionner un livreur</span>}</h4>
                        <BrowserView>
                            <TextPargraph style={{size:'small'}}  text={_Item.description} textminlength={100} />                
                            <div className="livraison">
                                <div className="delivery-select" style={{width:'90%',textAlign:'center',margin:'auto',marginBottom:'10px'}}>
                                    <Select 
                                        isClearable={false} 
                                        options={delivers}
                                        isSearchable = {false}
                                        value={!!_Item.deliver ? {value:{id:_Item.id,title:_Item.title},label:DeliverOption(_Item.deliver)} : null}
                                        placeholder={"Choississez votre livraison"}
                                        onChange={(value,action)=>{
                                            onDeliverChange(value.value.id);
                                        }}    
                                    />
                                </div>
                                <span style={{backgroundColor:Enabled.bg,color:Enabled.color,fontSize:'small'}}>
                                    Livraison jusqu'à chez vous pour {_Item.prices.delivery} €
                                </span>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="livraison">
                                <span style={{backgroundColor:Enabled.bg,color:Enabled.color}}>
                                    Livraison depuis {_Item.article.delivery_from} jusqu'aux Comores pour {_Item.prices.delivery} €
                                </span>
                            </div>
                            <div className="PanierItemControls" style={{width:'100%',marginBottom:'5px'}}>
                                <div style={{display:'inline-block'}}>
                                    <label style={{marginRight:'10px'}}>Quantité :</label>
                                    <input min={1} onChange={e=>{onQuantityChange(e.target.value);}} type="number" defaultValue={_Item.quantity} style={{width:'60px'}}/>
                                    <span style={{fontWeight:'bolder',marginLeft:'10px'}}>{_Item.prices.articles} €</span>
                                    <span style={{marginLeft:'10px',color:stockNotif.color}}>({stockNotif.text})</span>
                                    {_Item.is_location && (
                                    <div><label style={{marginRight:'10px'}}>Dates :</label>
                                    <DatePicker multiple
                                        onChange={(dates)=>{console.log(dates);onLocationDatesChange(dates);}}
                                        value={locationDates}
                                        minDate={new Date()}
                                        style={{width:"80%",marginTop:'8px',height:'22px',marginLeft:'5px',textAlign:'center'}}
                                        mapDays={({date})=>{
                                            const _dates = _Item.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                            const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                            return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                        format='DD/MM/YYYY' placeholder='Choisissez vos dates' />
                                    </div>)}
                                    <div className="delivery-select" style={{zIndex:99999,width:'90%',textAlign:'left',margin:'auto',marginTop:'5px',marginBottom:'10px'}}>
                                        <label style={{marginRight:'10px'}}>Livraison :</label>
                                        <Select 
                                            isClearable={false} 
                                            options={delivers}
                                            isSearchable = {false}
                                            value={!!_Item.deliver ? {value:{id:_Item.id,title:_Item.title},label:DeliverOption(_Item.deliver)} : null}
                                            placeholder={"Livreur"}
                                            styles={{menuPortal:(base)=>({...base, zIndex:99999})}} 
                                            onChange={(value,action)=>{
                                                onDeliverChange(value.value.id); 
                                            }}    
                                        />
                                </div>
                                </div>
                                <img src={removeIcon} onClick={e=>{remove();}} style={{float:'right',borderStyle:'none',borderRadius:'5px',width:'20px'}} />
                            </div>
                        </MobileView>
                    </div>
                <BrowserView>
                    <div className="PanierItemControls">
                            <label style={{marginRight:'10px'}}>Quantité :</label>
                            <input min={1} onChange={e=>{onQuantityChange(e.target.value);}} type="number" defaultValue={_Item.quantity} style={{width:'60px'}}/>
                            <span style={{fontWeight:'bolder',marginLeft:'10px'}}>{_Item.prices.articles} €</span>
                            <span style={{marginLeft:'10px',color:stockNotif.color,marginRight:'20px',fontSize:'small'}}>({stockNotif.text})</span>
                            <div style={{marginTop:'10px'}}>
                                {_Item.is_location && (
                                <>
                                <label style={{marginRight:'10px'}}>Dates :</label>
                                <DatePicker multiple
                                    onChange={onLocationDatesChange}
                                    minDate={new Date()}
                                    style={{width:"70%",height:'25px',marginLeft:'5px',textAlign:'center'}}
                                    value={locationDates}
                                    mapDays={({date})=>{
                                        let _dates = _Item.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                        const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                        return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                    format='DD/MM/YYYY' placeholder='Choisissez vos dates' />
                                    </>)}
                                <input onClick={e=>{remove();}} style={{float:'right',marginTop:'5px',backgroundColor:'#FFCCCB',borderStyle:'none',borderRadius:'5px',padding:'5px 10px',margin:'0px 10px 10px 0px'}} type="button" value={'Supprimer'} />
                            </div>
                    </div>
                </BrowserView>
            </fieldset>
    );
}